import { render } from "./emailMsgAdd.vue?vue&type=template&id=e21dc43a&scoped=true"
import script from "./emailMsgAdd.vue?vue&type=script&lang=js"
export * from "./emailMsgAdd.vue?vue&type=script&lang=js"

import "./emailMsgAdd.vue?vue&type=style&index=0&id=e21dc43a&scoped=true&lang=stylus&rel=stylesheet%2Fstylus"

import exportComponent from "/opt/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e21dc43a"]])

export default __exports__